import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import MeetingFormLayer from "../components/MeetingFormLayer";

const MeetingFormPage = () => {
    return (
        <MasterLayout>
            <MeetingFormLayer />
        </MasterLayout>
    );
};

export default MeetingFormPage;
